import React, { useState, useEffect, useRef, useCallback } from "react";
import {
    Grid,
    Container,
    Box,
    Typography,
    Button,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from "@mui/material";
import Loader from "../../components/Loader";
import { withTranslation } from "react-i18next";
import { GetAuditTrailSearchUrl, GetAuditTrailExcel } from "../../utils/constants";
import { axiosGet } from "../../utils/Axios";
import CommonPagination from "../../components/CommonPagination";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useToast } from '../../components/toast';
import moment from "moment";
import _ from 'lodash';
import { HeaderBlock } from "@colliers/colliers-b2c";
import axios from 'axios';


const AuditTrial = () => {
    const navigate = useNavigate();

    const { ToastComponent, showToast } = useToast();
    const { t } = useTranslation();

    const [isLoading, setIsLoading] = useState(false);
    const [reset, setReset] = useState(false);

    const [dateRange, setDateRange] = useState("");
    const [showDatePickers, setShowDatePickers] = useState(false);
    const openDatePickers = () => {
        setShowDatePickers(true);
    };
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const fromDateRef = useRef("");
    const toDateRef = useRef("");
    const handleFromDateChange = useCallback(
        _.debounce((event) => {
            if (event != "" && event != null && event != undefined) {
                const formattedfromDate = moment(event, "YYYY-MM-DD HH:mm:ss").format("DD-MMM-YYYY");
                setFromDate(event);
                fromDateRef.current = formattedfromDate;
                console.log("fromDate:", fromDate);
                handleDateChange();
            }
        }, 300), []);

    const handleToDateChange = useCallback(
        _.debounce((event) => {
            if (event != "" && event != null && event != undefined) {
                const formattedtoDate = moment(event, "YYYY-MM-DD HH:mm:ss").format("DD-MMM-YYYY");
                setToDate(event);
                toDateRef.current = formattedtoDate;
                handleDateChange();
            }
        }, 300), []);
    const handleDateChange = (_event) => {
        if (fromDateRef.current && !toDateRef.current) {
            setDateRange("greater than " + fromDateRef.current);
        }
        else if (toDateRef.current && !fromDateRef.current) {
            setDateRange("less than " + toDateRef.current);
        }
        else if (toDateRef.current && fromDateRef.current) {
            setDateRange("Between " + fromDateRef.current + " and " + toDateRef.current);
        }
        else if (fromDateRef.current || toDateRef.current) {
            setDateRange("");
        }
    }
    const handleFromKeyDown = (e) => {
        if (e.key === 'Backspace' || e.key === 'Delete') {
            setFromDate('');
            fromDateRef.current = "";
            handleDateChange();
        }
    };
    const handleToKeyDown = (e) => {
        if (e.key === 'Backspace' || e.key === 'Delete') {
            setToDate('');
            toDateRef.current = "";
            handleDateChange();
        }
    }
    const [emailText, setEmailText] = useState("");

    const [auditTrailList, setAuditTrailList] = useState([]);
    const [filteredAuditTrail, setFilteredAuditTrail] = useState(auditTrailList);

    const [currentPage, setCurrentPage] = useState(1);
    const listItemsPerPage = 10;
    const startIndex = (currentPage - 1) * listItemsPerPage;
    const paginatedAuditTrail = filteredAuditTrail?.slice(startIndex, startIndex + listItemsPerPage);
    const totalItems = filteredAuditTrail?.length;

    useEffect(() => {
        const userInfo = localStorage.getItem("userInfo");
        if (userInfo == null) {
            navigate("/login/KeyStone_Login");
            return;
        } else {
            const extractAccess = JSON.parse(localStorage.getItem('matchedModule'))
            const readAccess = extractAccess.read
            if (!readAccess) {
                navigate('/access-denied')
                return
            }
            getAuditTrailList();
        }
    }, [reset]);

    const searchBtnCall = async () => {
        setReset(false)
        getAuditTrailList();
    }
    const resetSearch = async () => {
        setFromDate("");
        setToDate("");
        setEmailText("");
        setDateRange("");
        setShowDatePickers(false);
        setReset(true)
    };
    const getAuditTrailList = async () => {
        setIsLoading(true);

        try {
            const validatedEmail = emailText ? emailText : ""

            let formattedDateRange = "";

            if (dateRange && dateRange.toString().indexOf("Between") > -1) {
                formattedDateRange = fromDateRef.current + "|" + toDateRef.current;
            } else if (dateRange) {
                formattedDateRange = dateRange;
            }
            const response = await axiosGet(GetAuditTrailSearchUrl, {
                dateRange: formattedDateRange,
                email: validatedEmail
            });

            if (response) {
                setAuditTrailList(response);
                setFilteredAuditTrail(response);
            } else {
                showToast('error', 'Failed to fetch Audit Trail: No data found.');
            }
        } catch (error) {
            showToast('error', 'Failed to fetch Audit Trail: No data found.');
        } finally {
            setIsLoading(false);
        }
    }
    const exportBtnCall = async () => {
        setIsLoading(true);
        try {
            const validatedEmail = emailText ? emailText : ""

            let formattedDateRange = "";

            if (dateRange) {
                const dateRangeStr = dateRange.toString();
                if (dateRangeStr.includes("Between")) {
                    formattedDateRange = fromDateRef.current + "|" + toDateRef.current;
                } else {
                    formattedDateRange = dateRange;
                }
            }

            const response = await axios.get(GetAuditTrailExcel, {
                params: {
                    dateRange: formattedDateRange,
                    email: validatedEmail
                },
                responseType: 'blob'
            });
            if (response) {
                const blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });
                let fileName = "AuditTrail.xlsx";
                const disposition = response.headers['content-disposition'];
                if (disposition) {
                    const filenameStarMatch = disposition.match(/filename\*\=UTF-8''(.+?)(?:;|$)/);
                    if (filenameStarMatch && filenameStarMatch[1]) {
                        fileName = decodeURIComponent(filenameStarMatch[1]);
                    } else {
                        const filenameMatch = disposition.match(/filename="?([^\";]+)"?/);
                        if (filenameMatch && filenameMatch[1]) {
                            fileName = filenameMatch[1];
                        }
                    }
                }
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
            else {
                showToast('error', 'Failed to generate excel');
            }
        } catch (error) {
            showToast('error', 'Failed to generate excel');
        } finally {
            setIsLoading(false);
        }
    }
    const handleEmailChange = (event) => {
        setEmailText(event.target.value);
    };

    return (
        <>
            {isLoading ? <Loader /> : <></>}
            <HeaderBlock left="" title={t('auditTrail.auditTrail')} leftCenterAlign="true" actionsCenterAlign="true" />

            <main
                id="main" className="auditTrailMain">

                <>

                    <Box>
                        {/* Search Filters */}
                        <Box className="margin-bottom-m">
                            <Grid container spacing={2}>
                                {/* Date Range Input */}
                                <Grid item xs={12} md={3}>
                                    <Typography className="cus-label-date" variant="subtitle2" gutterBottom>
                                        {t('dashboard_log.dateRange')}
                                    </Typography>
                                    {/* label={t('dashboard_log.dateRange')} */}

                                    <TextField className="auditTrailMarginTop"
                                        fullWidth
                                        value={dateRange}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        variant="outlined"
                                        onClick={openDatePickers}
                                        placeholder={t('auditTrail.selectDate')}
                                    />
                                    {showDatePickers === true && (
                                        <div className="auditTrailDate">
                                            <TextField
                                                fullWidth
                                                type="date"
                                                value={fromDate}
                                                onChange={(e) => handleFromDateChange(e.target.value)}
                                                required
                                                variant="outlined"
                                                onKeyDown={handleFromKeyDown}
                                            />
                                            <TextField
                                                fullWidth
                                                type="date"
                                                value={toDate}
                                                onChange={(e) => handleToDateChange(e.target.value)}
                                                required
                                                variant="outlined"
                                                onKeyDown={handleToKeyDown}
                                            />
                                        </div>
                                    )}
                                </Grid>

                                {/* Email Input */}
                                <Grid item xs={12} md={3}>
                                    {/* <Typography variant="subtitle2" sx={{marginBottom:'0px'}} gutterBottom>
                                                {t('auditTrail.email')}
                                            </Typography> */}

                                    {/* <Typography className="cus-label-date" variant="subtitle2" gutterBottom>
                                                Email
                                            </Typography> */}
                                    <TextField

                                        className="space-lab"
                                        sx={{ maxWidth: "350px", width: '350px', paddingTop: "10px" }}
                                        label={t('dashboard_log.name')}
                                        placeholder={t('dashboard_log.enterAName')}
                                        fullWidth
                                        variant="outlined"
                                        value={emailText}
                                        onChange={handleEmailChange}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>
                                {/* View Button */}
                                <Grid item xs={12} md={1}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        sx={{ mt: 1 }}
                                        fullWidth
                                        onClick={() => searchBtnCall()}
                                    >
                                        {t('common.view')}
                                    </Button>
                                </Grid>
                                <Grid item xs={12} md={1}>

                                    <Button
                                        variant="contained"
                                        color="primary"
                                        sx={{ mt: 1 }}
                                        fullWidth
                                        onClick={() => resetSearch()}
                                    >
                                        {t('common.reset')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>

                        {/* Record Info */}
                        <Box sx={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
                            <Typography className="table-rec" variant="body2">{t('common.total')} {totalItems} {t('common.recordsFound')}</Typography>
                            <Button
                                variant="outlined"
                                color="primary"
                                sx={{ borderColor: "#25408f" }}
                                onClick={() => exportBtnCall()}
                            >
                                {t('common.exportToExcel')}
                            </Button>
                        </Box>

                        {/* Data Table */}
                        <TableContainer component={Paper} sx={{ mb: 3 }} className="list-height-aud">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>{t('auditTrail.actionedDateTime')}</TableCell>
                                        <TableCell>{t('auditTrail.actionedBy')}</TableCell>
                                        <TableCell>{t('auditTrail.userType')}</TableCell>
                                        <TableCell>{t('auditTrail.dashboard')}</TableCell>
                                        <TableCell>{t('auditTrail.group')}</TableCell>
                                        <TableCell>{t('auditTrail.lang')}</TableCell>
                                        <TableCell>{t('auditTrail.action')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {paginatedAuditTrail?.length > 0 ? (
                                        paginatedAuditTrail?.map((auditTrail, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{moment(auditTrail.actionDate, "DD-MM-YYYY HH:mm:ss").isValid()
                                                    ? moment(auditTrail.actionDate, "DD-MM-YYYY HH:mm:ss").format("DD MMM YYYY HH:mm:ss")
                                                    : t('common.invalidDate')}</TableCell>
                                                <TableCell>{auditTrail.actionBy}</TableCell>
                                                <TableCell>{auditTrail.userType}</TableCell>
                                                <TableCell>{auditTrail.dashboard}</TableCell>
                                                <TableCell>{auditTrail.dashboardGroup}</TableCell>
                                                <TableCell>{auditTrail.lang}</TableCell>
                                                <TableCell>{auditTrail.action}</TableCell>
                                            </TableRow>
                                        ))) : (
                                        <TableCell colSpan={7}>{t('common.noRecordsFound')}</TableCell>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        {/* Pagination */}
                        <CommonPagination
                            totalItems={totalItems}
                            currentPage={currentPage}
                            onPageChange={setCurrentPage}
                        />
                    </Box>
                    <Box sx={{ height: '50px' }}></Box>
                </>

            </main>
            {ToastComponent}
        </>
        //    )}
        //</>
    );
};

export default withTranslation()(AuditTrial);
